(function () {
  'use strict';
  function init(root) {
    if (!root || root.dataset.catalogReady === 'true') return;
    root.dataset.catalogReady = 'true';
    var kind = root.dataset.editableCatalog;
    document.body.classList.add('template-collection-' + (kind === 'plan' ? 'planes' : 'ebooks') + '-cooldo');
    var cards = Array.from(root.querySelectorAll('[data-catalog-card]'));
    root.querySelectorAll('[data-plan-description], [data-ebook-description]').forEach(function (element) {
      var pattern = /[\u2600-\u27BF\u{1F300}-\u{1FAFF}]\uFE0F?/gu;
      if (pattern.test(element.textContent)) element.textContent = element.textContent.replace(pattern, '').trim();
    });
    var buttons = Array.from(root.querySelectorAll('[data-catalog-goal]'));
    var showAll = root.querySelector('[data-catalog-show-all]');
    var empty = root.querySelector('[data-plans-objective-empty], [data-ebooks-goal-empty]');
    var limit = Math.max(1, Number(root.dataset.initialCount) || cards.length);
    var revealed = false;
    var goal = 'all';
    cards.sort(function (a, b) { return Number(a.dataset.priority) - Number(b.dataset.priority); });
    cards.forEach(function (card, i) {
      card.style.setProperty(kind === 'plan' ? '--card-order' : '--ebook-order', i + 1);
    });
    function matches(card, key) { return key === 'all' || (card.dataset.categories || '').indexOf('|' + key + '|') !== -1; }
    function apply(next, updateUrl) {
      if (next !== 'all' && !buttons.some(function (button) { return button.dataset.catalogGoal === next; })) next = 'all';
      goal = next;
      buttons.forEach(function (button) {
        var key = button.dataset.catalogGoal;
        button.hidden = root.dataset.hideEmpty === 'true' && key !== 'all' && !cards.some(function (card) { return matches(card, key); });
        button.setAttribute('aria-pressed', String(key === goal));
      });
      var count = 0;
      cards.forEach(function (card, i) {
        var match = matches(card, goal);
        var extra = goal === 'all' && !revealed && i >= limit;
        card.classList.toggle(kind === 'plan' ? 'is-objective-hidden' : 'is-goal-hidden', !match);
        card.classList.toggle('is-extra', extra);
        card.hidden = !match || extra;
        if (!card.hidden) count++;
      });
      if (empty) empty.hidden = count > 0;
      if (showAll) showAll.hidden = revealed || goal !== 'all' || cards.length <= limit;
      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.delete('filter.p.m.custom.objetivo');
        if (goal === 'all') url.searchParams.delete('goal'); else url.searchParams.set('goal', goal);
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      }
    }
    buttons.forEach(function (button) { button.addEventListener('click', function () { apply(button.dataset.catalogGoal, true); }); });
    if (showAll) showAll.addEventListener('click', function () { revealed = true; apply(goal, false); });
    var sortPanel = root.querySelector('[data-catalog-sort-panel]');
    if (sortPanel) sortPanel.open = root.dataset[window.matchMedia('(max-width: 749px)').matches ? 'openMobile' : 'openDesktop'] === 'true';
    var sort = root.querySelector('[data-catalog-sort]');
    if (sort) sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });
    function restore() { if (root.isConnected) apply(new URL(window.location.href).searchParams.get('goal') || 'all', false); }
    restore();
    window.addEventListener('popstate', restore);
    root.catalogCleanup = function () { window.removeEventListener('popstate', restore); };
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-editable-catalog]')) init(scope);
    scope.querySelectorAll('[data-editable-catalog]').forEach(init);
  }
  scan(document);
  // A page may contain more than one catalog and more than one script tag.
  if (!window.cooldoEditableCatalogEvents) {
    window.cooldoEditableCatalogEvents = true;
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-editable-catalog]').forEach(function (root) { if (root.catalogCleanup) root.catalogCleanup(); });
    });
  }
}());
